/* eslint-disable max-len */
import React, {FC} from "react"

import id from "@irati/utils/id"

import BaseSvgIcon from "./Base"

interface Props {
  id: string
  title: string
}
const AddComment: FC<Props> = (props) => {
  const titleId = id("title", props)
  const {title, ...rest} = props

  return (
    <BaseSvgIcon {...rest} aria-labelledby={titleId}>
      <title id={titleId}>{title}</title>
      <g fill="none" fillRule="evenodd">
        <rect height="18" rx="1" width="18" />
        <g fill="currentColor">
          <rect height="1" rx=".5" width="7" y="3" />
          <rect height="7" rx=".5" width="1" x="3" />
          <rect height="1" rx=".5" width="6" x="5.5" y="5.5" />
          <rect height="1" rx=".5" width="6" x="7" y="8" />
        </g>
        <path
          d="m8.99493813 1.5c4.10648697 0 7.49999997 2.5451348 7.49999997 5.79545455 0 1.15777909-.4366338 2.25966611-1.2325726 3.19323125-.0280446.0451667-.062397.0887022-.1034909.1297961l-.174238.1741762c-.0494695.0502205-.0494695.0502205-.0943581.0944199l-5.41322211 5.4132221c-.4295215.4295215-1.16393645.1253168-1.16393645-.4821183v-2.7508322c-2.77119949-.1923552-5.1320135-1.7404626-6.20325666-3.53545228"
          fillRule="nonzero"
          stroke="currentColor"
          strokeLinecap="round"
        />
      </g>
    </BaseSvgIcon>
  )
}

AddComment.defaultProps = {
  id: "add-comment-icon",
  title: "Add a comment"
}

export default AddComment
